import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import EditLocationRoundedIcon from '@material-ui/icons/EditLocationRounded';
import HelpRoundedIcon from '@material-ui/icons/HelpRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import LocationOffRoundedIcon from '@material-ui/icons/LocationOffRounded';
import Brightness7RoundedIcon from '@material-ui/icons/Brightness7Rounded';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: 'fixed',
    zIndex: 20,
    top: theme.spacing(1.5),
    right: theme.spacing(2)
  }
}));

export const actions = [
  {
    icon: <EditLocationRoundedIcon />,
    cancelIcon: <LocationOffRoundedIcon />,
    name: 'Marker Mode',
    cancelName: 'Exit Marker Mode',
    operation: 'location',
    fabProps: {}
  },
  {
    icon: <HomeRoundedIcon />,
    name: 'Website',
    operation: 'website',
    fabProps: { href: 'https://idemandinsurance.com/' }
  },
  { icon: <HelpRoundedIcon />, name: 'Info', operation: 'info', fabProps: {} },
  {
    icon: <DescriptionRoundedIcon />,
    name: 'Product Descriptions',
    operation: 'products',
    fabProps: {}
  },
  {
    icon: <Brightness7RoundedIcon />,
    name: 'Light/Dark Theme',
    operation: 'theme',
    fabProps: {}
  }
  // {
  //   icon: <Brightness7RoundedIcon />,
  //   name: 'Carrier Analysis',
  //   operation: 'carrier',
  //   fabProps: {}
  // }
];

// TODO: remove carrier stuff

const FabMenu = ({
  markerMode,
  updateMarkerMode,
  setDirectionsOpen,
  setShowExplainer,
  switchTheme,
  setShowCarrierUpload
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  let handleClick = (e, operation) => {
    if (operation === 'location') updateMarkerMode(!markerMode);
    if (operation === 'website') return;
    if (operation === 'info') setDirectionsOpen(true);
    if (operation === 'products') setShowExplainer(true);
    if (operation === 'theme') switchTheme();
    // if (operation === 'carrier') setShowCarrierUpload(true);
  };

  return (
    <SpeedDial
      ariaLabel='Menu'
      className={classes.speedDial}
      icon={
        <SpeedDialIcon
          icon={<MenuRoundedIcon />}
          openIcon={<CloseRoundedIcon />}
        />
      }
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction='down'
      FabProps={{
        color: 'secondary',
        size: 'medium'
      }}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={
            action.operation === 'location' && markerMode
              ? action.cancelIcon
              : action.icon
          }
          tooltipTitle={
            action.operation === 'location' && markerMode
              ? action.cancelName
              : action.name
          }
          onClick={(e) => handleClick(e, action.operation)}
          FabProps={action.fabProps}
        />
      ))}
    </SpeedDial>
  );
};

FabMenu.propTypes = {
  markerMode: PropTypes.bool.isRequired,
  updateMarkerMode: PropTypes.func.isRequired,
  setDirectionsOpen: PropTypes.func.isRequired,
  setShowExplainer: PropTypes.func.isRequired,
  switchTheme: PropTypes.func.isRequired
  // setShowCarrierUpload: PropTypes.func
};

export default FabMenu;
